import React, { Component } from 'react';
import { View, ScrollView, KeyboardAvoidingView, Platform, Keyboard, StyleSheet } from 'react-native';
import { Input, Button, Modal, Text, Card, Radio, Layout } from '@ui-kitten/components';
import { ApiClient } from '../../data/api/client/ApiClient';
import { setCurrentUser } from '../../utils/setCurrentUser';
import { ResponsiveWrapper } from './../../components/containers/ResponsiveWrapper';
import { authToken } from '../../data/api/client/authToken';
import { AuthContext, CurrentUser } from './../../App';
import { LoadingIndicator } from '../../components/LoadingIndicator';
import { PlanTypeOptions, PricePlan, PRICE_PLANS, PricePlanCard } from '../home.screen';
import { BrandText } from '../../components/brandText';

export const LoginOrSignupScreen = (props) => {
    const { signIn } = React.useContext(AuthContext);
    // const _onSignIn = () => signIn();
    console.log('LoginOrSignupScreen ', props);
    return (
        // <Text>LoginOrSignupScreen</Text>
        <LoginOrSignup
            onSignIn={signIn}
            {...props}
        />
    );
}


interface LoginOrSignupProps {
    route: any;
    navigation: any;
    onSignIn: (jwt_token: string, user: CurrentUser) => Promise<void>
}
interface LoginOrSignupState {
    actionType: 'login' | 'signup',
    planType: PlanTypeOptions,
    keyboardVisible: boolean,
    showModal: boolean,
    modalMessage: string,
    loading: boolean,
    email: string,
    username: string,
    password: string,
    emailErrorMessage: string,
    usernameErrorMessage: string,
    passwordErrorMessage: string,
    loginEmail: string,
    loginPassword: string,
    planTypeErrorMessage: string;
    loginEmailErrorMessage: string,
    loginPasswordErrorMessage: string
}
class LoginOrSignup extends Component<LoginOrSignupProps, LoginOrSignupState> {
    keyboardDidShowListener: any;
    keyboardDidHideListener: any;
    statekeyboardVisible: boolean;
    constructor(props: Readonly<LoginOrSignupProps>) {
        super(props);
        console.log('export class LoginOrSignupScreen extends Component     this.props.route', this.props.route);
        const params: any = this.props.route && this.props.route.params ? this.props.route.params : undefined;
        const actionType = params && this.props.route.params.actionType ? this.props.route.params.actionType : undefined;
        const planType: PlanTypeOptions = params && this.props.route.params.planType ? this.props.route.params.planType : undefined;
        this.state = {
            actionType: actionType || 'login',
            planType: planType || PlanTypeOptions.BASIC,
            keyboardVisible: false,
            showModal: false,
            modalMessage: '',
            loading: false,

            email: '',
            username: '',
            password: '',
            emailErrorMessage: undefined,
            usernameErrorMessage: undefined,
            passwordErrorMessage: undefined,
            planTypeErrorMessage: undefined,

            // user-role: ?
            // loginEmail: __DEV__ ? 'poall@email.com' : undefined,
            // user-role: Basic
            // loginEmail: __DEV__ ? 't_user_1@email.com' : undefined,
            // user-role: Premium
            loginEmail: __DEV__ ? 't_user_2@email.com' : undefined,
            
            loginPassword: __DEV__ ? 't_user_1' : undefined,
            // loginEmail: undefined,
            // loginPassword: undefined,
            loginEmailErrorMessage: undefined,
            loginPasswordErrorMessage: undefined
        };
    }

    componentDidMount() {
        console.log(`<LoginOrSignupScreen>.componentDidMount()`);
        // this._focusListener = this.props.navigation.addListener('focus', () => {
        //     console.log(`<LoginOrSignupScreen> this._focusListener = this.props.navigation.addListener('focus', () => {`);
        //     // If we have a token, the user is logged in
        //     // temp placeholder until login logic is moved to app.tsx
        //     if (authToken) {
        //         console.log('User is logged in... navigating to account page');
        //         this.props.navigation.navigate('Account', { screen: 'Overview' });
        //     }
        //     else {
        //         console.log('User is not logged in... there was no auth tkn');
        //     }
        // });

        this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow);
        this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide);
    }

    componentDidUpdate() {
        // If we have a token, the user is logged in
        // temp placeholder until login logic is moved to app.tsx
        if (authToken) {
            console.log('User is logged in... navigating to account page');
            // this.props.navigation.navigate('Account', { screen: 'Overview' });
        }
        else {
            console.log('User is not logged in... there was no auth tkn');
        }
    }

    componentWillUnmount() {
        this.keyboardDidShowListener.remove();
        this.keyboardDidHideListener.remove();
    }

    _keyboardDidShow = () => {
        console.log('Keyboard Shown');
        this.setState({ keyboardVisible: true });
    }

    _keyboardDidHide = () => {
        console.log('Keyboard Hidden');
        this.setState({ keyboardVisible: false });
    }

    render() {
        console.log('LoginOrSignupScreen.render() props, nav', this.state);
        const keyboardVerticalOffset = Platform.OS === 'ios' ? 40 : 0;
        const { usernameErrorMessage, emailErrorMessage, passwordErrorMessage, loginEmailErrorMessage, loginPasswordErrorMessage, planTypeErrorMessage } = this.state;
        
        const usernameError = (usernameErrorMessage && usernameErrorMessage.length > 0);
        const emailError = (emailErrorMessage && emailErrorMessage.length > 0);
        const passwordError = (passwordErrorMessage && passwordErrorMessage.length > 0);        
        const loginEmailError = (loginEmailErrorMessage && loginEmailErrorMessage.length > 0);
        const loginPasswordError = (loginPasswordErrorMessage && loginPasswordErrorMessage.length > 0);
        const planTypeError = (planTypeErrorMessage && planTypeErrorMessage.length > 0);
        return (
            // <ScrollView contentContainerStyle={{ paddingHorizontal: 30, flexGrow: 1, justifyContent : 'center' }} keyboardShouldPersistTaps='always'>
            //     <KeyboardAvoidingView enabled={this.statekeyboardVisible} behavior='position' keyboardVerticalOffset={keyboardVerticalOffset} style={{ paddingHorizontal: 30 }}>
            <ScrollView
                contentContainerStyle={{
                    // backgroundColor: '#ffffff',
                    flexGrow: 1
                    // , paddingHorizontal: 30, flexGrow: 1, justifyContent : 'center'
                }}
                keyboardShouldPersistTaps='always'
            >
                <Layout level='1' style={{ flex: 1 }}>
                    <KeyboardAvoidingView
                        enabled={this.statekeyboardVisible}
                        behavior='position'
                        keyboardVerticalOffset={keyboardVerticalOffset}
                        style={{ flex: 1, flexGrow: 1 }}
                        contentContainerStyle={{ flex: 1, flexGrow: 1 }}
                    >
                        
                        <ResponsiveWrapper maxWidth={500}>
                            
                            {/* <Image
                                resizeMode='contain'
                                style={[styles.responsiveImage, { height: 200, width: 200, alignSelf: 'center' }]}
                                source={poallImages.poall_logo_large}
                            /> */}
                            <BrandText style={{ fontSize: 150, lineHeight: 250, textAlign: 'center'  }} status='primary'>pll</BrandText>
                            {
                                this.state.actionType === 'login' ?
                                <View style={{ paddingHorizontal: 60, flex: 1, }}>
                                    <Text style={{ marginBottom: 50 }} category='h1'>{'Login'}</Text>
                                    <View style={{ marginBottom: 20 }}>
                                        <Input
                                            label='Email'
                                            placeholder='Email'
                                            value={this.state.loginEmail}
                                            onChangeText={(text) => this.setState({ loginEmail: text })}
                                            status={loginEmailError ? 'danger' : undefined}
                                            autoCapitalize='none'
                                        />
                                        {loginEmailError ? <Text style={{ color: 'red' }}>{loginEmailErrorMessage}</Text> : undefined}
                                    </View>
                                    <View style={{ marginBottom: 40 }}>
                                        <Input
                                            label='Password'
                                            placeholder='Password'
                                            value={this.state.loginPassword}
                                            onChangeText={(text) => this.setState({ loginPassword: text })}
                                            secureTextEntry
                                            status={loginPasswordError ? 'danger' : undefined}
                                            autoCapitalize='none'
                                        />
                                        {loginPasswordError ? <Text style={{ color: 'red' }}>{loginPasswordErrorMessage}</Text> : undefined}
                                    </View>

                                    <View style={{ marginBottom: 40 }}>
                                        <Button /* icon='camera' */ appearance='filled' onPress={() => this._loginUser()}>
                                            Login
                                        </Button>
                                    </View>

                                    <View style={{ marginBottom: 40 }}>
                                        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                            <Text>Don't have an account?</Text>
                                            <Button /* icon='camera' */ appearance='ghost' onPress={() => this.setState({ actionType: 'signup' })}>
                                                Sign Up
                                            </Button>
                                        </View>
                                    </View>
                                </View>
                                : <View style={{ paddingHorizontal: 60 }}>
                                    <Text style={{ marginBottom: 50 }} category='h1'>{'Sign Up'}</Text>
                                    <View style={{ marginBottom: 20 }}>
                                        <Input
                                            label='Username'
                                            placeholder='Username'
                                            value={this.state.username}
                                            onChangeText={(text) => this.setState({ username: text })}
                                            status={usernameError ? 'danger' : undefined}
                                            autoCapitalize='none'
                                        />
                                        {usernameError ? <Text style={{ color: 'red' }}>{usernameErrorMessage}</Text> : undefined}
                                    </View>
                                    <View style={{ marginBottom: 20 }}>
                                        <Input
                                            label='Email'
                                            placeholder='Email'
                                            value={this.state.email}
                                            onChangeText={(text) => this.setState({ email: text })}
                                            status={emailError ? 'danger' : undefined}
                                            autoCapitalize='none'
                                        />
                                        {emailError ? <Text style={{ color: 'red' }}>{emailErrorMessage}</Text> : undefined}
                                    </View>
                                    <View style={{ marginBottom: 20 }}>
                                        <Input
                                            label='Password'
                                            placeholder='Password'
                                            value={this.state.password}
                                            onChangeText={(text) => this.setState({ password: text })}
                                            secureTextEntry
                                            status={passwordError ? 'danger' : undefined}
                                            autoCapitalize='none'
                                        />
                                        {passwordError ? <Text style={{ color: 'red' }}>{passwordErrorMessage}</Text> : undefined}
                                    </View>
                                    <View style={{ marginBottom: 40 }}>
                                        <Text category='label' appearance='hint' style={{ marginBottom: 4 }}>Plan</Text>
                                        {
                                            PRICE_PLANS.map((p: PricePlan) => { p.featureList = []; p.price = undefined; return { ...p }; }).map((plan: PricePlan, index: number) =>
                                                <Layout
                                                    level={this.state.planType === plan.title ? '2' : undefined}
                                                    key={index}
                                                >
                                                    <PricePlanCard
                                                        pricePlan={plan}
                                                        actionItem={
                                                            <Radio
                                                                style={{ margin: 8, alignSelf: 'center' }}
                                                                checked={this.state.planType === plan.title}
                                                                text={plan.routeValue !== PlanTypeOptions.BASIC ? 'Coming Soon' : plan.title}
                                                                onChange={() => {
                                                                    if (plan.routeValue === PlanTypeOptions.BASIC) {
                                                                        this.setState({ planType: plan.title });
                                                                    }
                                                                }}
                                                                disabled={plan.routeValue !== PlanTypeOptions.BASIC}
                                                            />
                                                        }
                                                        onCardPress={() => {
                                                            if (plan.routeValue === PlanTypeOptions.BASIC) {
                                                                this.setState({ planType: plan.title });
                                                            }
                                                        }}
                                                        style={this.state.planType === plan.title ? { borderColor: '#3366ff' } : undefined}
                                                    />
                                                </Layout>
                                            )
                                        }
                                        {planTypeErrorMessage ? <Text style={{ color: 'red' }}>{planTypeErrorMessage}</Text> : undefined}
                                    </View>
                                    <View style={{ marginBottom: 40 }}>
                                        <Button /* icon='camera' */ appearance='filled' onPress={this._registerUser}>
                                            Sign Up
                                        </Button>
                                    </View>

                                    <View style={{ marginBottom: 40 }}>
                                        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                            <Text>Already have an account?</Text>
                                            <Button /* icon='camera' */ appearance='ghost' onPress={() => this.setState({ actionType: 'login' })}>
                                                Log In
                                            </Button>
                                        </View>
                                    </View>
                                </View>
                            }
                        </ResponsiveWrapper>
                    </KeyboardAvoidingView>


                    <Modal backdropStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onBackdropPress={this._hideModal} visible={this.state.showModal}>
                        <Card>
                            <Text style={{ marginBottom: 20 }}>{this.state.modalMessage}</Text>
                            <Button onPress={this._hideModal}>{' Okay '}</Button>
                        </Card>
                    </Modal>

                    <Modal backdropStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} visible={this.state.loading}>
                        <Card>
                            <LoadingIndicator />
                        </Card>
                    </Modal>
                </Layout>
            </ScrollView>
        );
    }

    _registerUser = async () => {
        try {
            Keyboard.dismiss();
            this.setState({
                usernameErrorMessage: undefined,
                passwordErrorMessage: undefined,
                emailErrorMessage: undefined,
                loading: true
            });


            if (this._inputsValid()) {
                const { username, password, email, planType } = this.state;
                console.table([username, password, email, planType]);
                const planTypeId = 1;
                // return;
                const response = await ApiClient.createUser(username, password, email, planTypeId);
                console.log('response', response);
                if (response.error) {
                    this.setState({
                        loading: false,
                        showModal: true,
                        modalMessage: response.error.message || 'There was an error during registration. Please try again.'
                    });
                }
                else {
                    const loginResponse = await ApiClient.loginAndGetToken(
                        email,
                        password
                    );
                    console.log('loginResponse', loginResponse);
                    if (loginResponse.error) {
                        this.setState({
                            loading: false,
                            showModal: true,
                            modalMessage: response.error.message || 'Your account was created successfully but there was an error during login. Please try again.'
                        });
                    }
                    else {
                        // const setCurrentUser = setCurrentUser(loginResponse.data.user);
                        this.setState({ loading: false });
                        // alert(`setCurrentUser = ${setCurrentUser}`);
                    }
                }
            }
            else {
                // there was an issue with the inputs
                this._hideModal();
                this.setState({ loading: false });
                return;
            }
        }
        catch (error) {
            console.log(error);
            this._hideModal();
            this.setState({ loading: false });
        }
    }


    _loginUser = async () => {
        try {
            Keyboard.dismiss();
            this.setState({
                emailErrorMessage: undefined,
                passwordErrorMessage: undefined,
                loading: true
            });
            if (this._loginInputsValid()) {
                const { loginEmail, loginPassword } = this.state;
                const response = await ApiClient.loginAndGetToken(loginEmail, loginPassword);
                console.log('response', response);
                if (response.error) {
                    this.setState({
                        loading: false,
                        showModal: true,
                        modalMessage: response.error.message || 'There was an error. Please try again.'
                    });
                }
                else {
                    this.props.onSignIn(response.data.jwt_token, response.data.user);
                    setCurrentUser(response.data.user);
                    const navAfterAuth = this.props.route && this.props.route.params && this.props.route.params.navAfterAuth ? this.props.route.params.navAfterAuth : undefined;

                    // const navAfterAuth = this.props.route.params.navAfterAuth;
                    if (navAfterAuth && navAfterAuth.route) {
                        // this._hideModal();
                        // this.setState({ loading: false });
                        this.setState(
                            () => ({ loading: false, showModal: false, modalMessage: undefined }),
                            () => this.props.navigation.navigate(navAfterAuth.route, navAfterAuth.params)
                        );
                        
                    }
                    else {
                        // this._hideModal();
                        console.log('() => this.props.navigation.navigate(Surveys)');
                        this.setState(
                            () => ({ loading: false, showModal: false, modalMessage: undefined }),
                            () => this.props.navigation.navigate('Surveys', { screen: 'All' })
                        );
                    }
                }
            }
            else {
                // there was an issue with the inputs
                // this._hideModal();
                this.setState({ loading: false, showModal: false, modalMessage: undefined });
                return;
            }
        }
        catch (error) {
            console.log(error);
            this._hideModal();
            this.setState({ loading: false });
        }
    }

    _loginInputsValid = () => {


        const email = this.state.loginEmail;
        const password = this.state.loginPassword;
        let emailValid = false;
        let emailErrorMessage = undefined;
        let passwordValid = false;
        let passwordErrorMessage = undefined;

        // email check
        if (email === undefined || email === null || email.length <= 0) {
            emailErrorMessage = 'Enter your email address';
        }
        else if (email.indexOf('@') <= 0 && email.indexOf('.') <= 0) {
            emailErrorMessage = 'Enter a valid email address';
        }
        else {
            emailValid = true;
        }

        // password check
        if (password === undefined || password === null || password.length <= 0) {
            passwordErrorMessage = 'Enter your password';
        }
        else {
            passwordValid = true;
        }

        // valid?
        if (emailValid && passwordValid) {
            return true;
        }
        else {
            this.setState({
                loginEmailErrorMessage: emailErrorMessage,
                loginPasswordErrorMessage: passwordErrorMessage,
            });
            return false;
        }
    }

    _inputsValid = () => {
        const username: string = this.state.username;
        const email: string = this.state.email;
        const password: string = this.state.password;
        const planType: string = this.state.planType;

        let usernameValid: boolean = false;
        let usernameErrorMessage: string = undefined;
        let planTypeValid: boolean = false;
        let planTypeErrorMessage: string = undefined;
        let emailValid: boolean = false;
        let emailErrorMessage: string = undefined;
        let passwordValid: boolean = false;
        let passwordErrorMessage: string = undefined;

        // username check
        if (username === undefined || username.length <= 0) {
            usernameErrorMessage = 'Enter a username';
        }
        else if (username.length < 4 || username.length > 40 ) {
            usernameErrorMessage = 'Enter a username (4-40 characters in length)';
        }
        else {
            usernameValid = true;
        }

        // email check
        if (email === undefined || email.length <= 0) {
            emailErrorMessage = 'Enter an email address';
        }
        else if (email.indexOf('@') <= 0 && email.indexOf('.') <= 0) {
            emailErrorMessage = 'Enter a valid email address';
        }
        else {
            emailValid = true;
        }

        // password check
        if (password === undefined || password.length <= 0) {
            passwordErrorMessage = 'Enter a password';
        }
        else if (password.length < 4 || password.length > 40 ) {
            passwordErrorMessage = 'Enter a password (4-40 characters in length)';
        }
        else {
            passwordValid = true;
        }

        // plan type check
        if (planType === undefined || planType.length <= 0 || !Object.values(PlanTypeOptions).includes(planType)) {
            planTypeErrorMessage = 'Select a plan';
        }
        else {
            planTypeValid = true;
        }

        // valid?
        if (usernameValid && emailValid && passwordValid && planTypeValid) {
            return true;
        }
        else {
            console.table([{
                usernameValid,
                usernameErrorMessage,
                emailValid,
                emailErrorMessage,
                passwordValid,
                passwordErrorMessage,
                planTypeValid,
                planTypeErrorMessage
            }]);
            this.setState({
                usernameErrorMessage: usernameErrorMessage,
                emailErrorMessage: emailErrorMessage,
                passwordErrorMessage: passwordErrorMessage,
                planTypeErrorMessage: planTypeErrorMessage,
            });
            return false;
        }
    }



    _showModal = (message) => this.setState({ showModal: true, modalMessage: message });
    _hideModal = () => this.setState({ showModal: false, modalMessage: undefined });
}

const styles = StyleSheet.create({
    responsiveImage: {
        width: '100%',
        // Without height undefined it won't work
        height: undefined,
        // figure out your image aspect ratio
        aspectRatio: 135 / 76,
    }
});


